import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

function Spotlight() {
    return (
        <Box
            id="spotlight"
            sx={{
                width: '100%',
                backgroundColor: '#141414',
                pt: 6,
                pb: 3,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>
                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/img/cloudathon-2024.jpg" // Replace with actual image path
                            alt="Community Spotlight"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        />
                    </Grid>

                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Celebrating Excellence
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                Community Spotlight
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                The Spotlight initiative is part of our recognition programs, dedicated to celebrating the exceptional achievements of individuals and organizations within the CSN community. This initiative aims to highlight those who have demonstrated exemplary dedication and innovation in the field of cloud security.
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                }}
                            >
                                By sharing their success stories, we aim to inspire others and showcase the impact of their contributions in advancing the field of cloud and security engineering.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Spotlight;
